import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import { TransportArticle } from "../models/transport-article.model";
import * as moment from "moment";

@Injectable({
    providedIn: "root"
  })

export class TransportArticlesService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-project-key', }) };
      this.baseUrl = `${this.configService.config.projectUrl}/api/transportarticles`;
    }

    getByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<TransportArticle[]> {
      const request = { "ProjectId": id, "FromDate": fromDate, "ToDate": toDate };

      return this.http.post<TransportArticle[]>(`${this.baseUrl}/getbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get transport articles`)));
    }

    getApprovedByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<TransportArticle[]> {
      const request = { "ProjectId": id, "FromDate": fromDate, "ToDate": toDate };

      return this.http.post<TransportArticle[]>(`${this.baseUrl}/getapprovedbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get transport articles`)));
    }

    getByTime(id: number): Observable<TransportArticle[]> {
      return this.http.get<TransportArticle[]>(`${this.baseUrl}/getbytimeid?timeId=${id}`, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get transport articles`)));
    }
}
